module.exports = __webpack_public_path__ + "img/my.b8113456.png";